// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-picker{position:relative}.color-picker .color-wrapper{display:inline-block;margin:0 .5rem}.color-picker .color-wrapper:first-child{margin-left:0}.color-picker .color-wrapper:last-child{margin-right:0}.color-picker .color{width:1.4rem;height:1.4rem;border-radius:50%;border:1px solid #e8e7e6;cursor:pointer}.color-picker .highlight{position:absolute;width:1.4rem;height:.12rem;background:#1c0f0c;left:0;transition:transform .2s cubic-bezier(.77,0,.175,1)}", ""]);
// Exports
module.exports = exports;
